import React, { FC } from 'react';

import Video from '../Video';
import Pagination from '../../Pagination';

import { IVideosListContent } from './interfaces';

import './styles.scss';

// news content
const VideosListContent: FC<IVideosListContent> = ({
  data,
  lang,
  page,
  onNextPrev,
  perPage,
}) => {
  // render
  return (
    <div
      className="videos-list-content">
      <div
        className="videos-list-content--container">
        {data?.items && data?.items.map((item: any, index: number) =>
          <Video
            {...item}
            lang={lang}
            key={index} />)}
      </div>
      
      {data?.meta &&
        <Pagination
          current={page}
          total={Math.ceil(data?.meta.total_count / perPage)}
          setCurrent={onNextPrev} />}
    </div>
  );
};

export default VideosListContent;